import Vue from 'vue';
import {
  apps
} from './config'
import jsCookie from 'js-cookie';
let defaultUrl = 'https://storage.hidreamai.com/image/'
export const defaultSnapshot = '?x-oss-process=video/snapshot,t_1,f_jpg,w_768,m_fast';
export const defaultSnapshotTimer = '?x-oss-process=video/snapshot,t_2500,f_jpg,w_768';
export const defaultVideoUrl = 'https://media.hidreamai.com/';
export const downloadWmUrl = '/api/gw/v2/downloads/media?type=video'
export const downloadWmMp4 = (baseUrl, key) => {
  Vue.prototype.$toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  });
  return fetch(baseUrl + downloadWmUrl + '&key=' + extractPath(key)).then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log(data)
      return data.result.url
    })
    .catch(error => {
      console.error('Fetch error:', error);
    }).finally(() => {
      Vue.prototype.$toast.clear();
    })
}

export function extractPath(url) {
  // 检查是否包含 ".com/"
  const comIndex = url.indexOf(".com/");
  if (comIndex !== -1) {
    // 截取 .com/ 后面的部分
    return url.substring(comIndex + 5) + '&wm=true';
  }
  // 如果没有 ".com/"，直接返回原始字符串
  return url + '&wm=true';
}
export function extractPathV2(url) {
  // 检查是否包含 ".com/"
  const comIndex = url.indexOf(".com/");
  if (comIndex !== -1) {
    // 截取 .com/ 后面的部分
    return url.substring(comIndex + 5);
  }
  // 如果没有 ".com/"，直接返回原始字符串
  console.log(url,'1111')
  return url;
}
export function GetQueryString(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
export function removeAfterQuestionMark(str) {
  return str.replace(/\?.*/, '');
}

export function masterUrl(url, checkType = false) {
  if (!url) return ''
  let ext = '.jpg'
  if (checkType) {
    ext = url.indexOf('p_') > -1 ? '.png' : '.jpg'
  }
  return defaultUrl + url + ext;
}
/**
 * 获取图片url
 * @export
 * @param {*} url
 * @param {number} [width=512]
 * @param {boolean} [ext=false] 是否显示原本后缀
 * @return {*} 
 */
export function changeUrl(url, width = 512, ext = false) {
  if (!url) return ''
  let finalUrl = "";
  if (url.indexOf(defaultUrl) !== -1) {
    if (url.indexOf(".jpg") !== -1) {
      let ipo = url.indexOf(".jpg");
      finalUrl = url.substring(0, ipo).replace(defaultUrl, "");
    }
    if (url.indexOf(".png") !== -1) {
      // 说明存在后缀，需要去除
      let ipo = url.indexOf(".png");
      finalUrl = url.substring(0, ipo).replace(defaultUrl, "");
    }
    // 说明存在域名，转为不存在的
  } else {
    // 需要添加域名及后缀
    let imageUrl = masterUrl(url, ext)
    finalUrl = imageUrl + "?width=" + width;
  }
  return finalUrl;
}
export function fileBase64(file) {
  //根据file文件流获取base64
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function () {
      imgResult = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(imgResult);
    };
  });
}
export function fakeProgressBar(duration, callback) {
  const steps = duration; // 总更新次数
  const interval = 1000; // 每秒更新一次
  let currentStep = 0; // 当前步骤
  let progress = 0; // 当前进度

  const timer = setInterval(() => {
    currentStep++;

    // 随机生成进度增量，确保进度递增并最终达到 1
    const remainingSteps = steps - currentStep;
    const increment = remainingSteps > 0 ?
      Math.random() * (1 - progress) / remainingSteps // 根据剩余步数动态调整增量范围
      :
      1 - progress; // 最后一步直接达到 1

    progress = Math.min(progress + increment, 1); // 确保 progress 不超过 1

    // 调用回调函数，传递当前进度
    callback(progress);

    // 如果达到最大步数，清除定时器
    if (currentStep >= steps || progress >= 1) {
      clearInterval(timer);
    }
  }, interval);
}
export function publishMg(params) {
  const urlfrom = localStorage.getItem('urlfrom')
  let publishUrl = urlfrom == 'FY' ? 'https://y.migu.cn/app/v5/zt/2025/newyear-publish/index.html' : 'https://y.migu.cn/app/v5/p/publish-mid/index.html'
  const uid = sessionStorage.getItem('uid') ?? ''
  const secret = sessionStorage.getItem('secret') ?? ''
  const watermarkId = sessionStorage.getItem('watermarkId') ?? ''
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const otherSet = sessionStorage.getItem('otherSet') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  const isMiniPublish = sessionStorage.getItem('isMiniPublish') ?? ''
  const url = `${publishUrl}?videoUrl=${encodeURIComponent(params.video)}&${urlfrom==='FY'?'coverUrl':'videoCover'}=${encodeURIComponent(params.cover)}&uid=${uid}&secret=${secret}&watermarkId=${watermarkId}&projectId=${apps.get(pId).projectId}&otherSet=${otherSet}&${urlfrom==='FY'?'columnId':'releaseId'}=${releaseId}&isMiniPublish=${isMiniPublish}`
  window.location.href = url
}
export function getLoginUrl(path,pId='mg-mczx') {
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  localStorage.setItem('backUrl', window.location.pathname.replace(path, ''))
  const url = `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${apps.get(pId).appId}&schannel=${apps.get(pId).schannel}&projectId=${apps.get(pId).projectId}&releaseId=${releaseId}`
  // if (url.toLowerCase().includes('ai-pet.tech')) {
  //   const cbURLParams = new URLSearchParams(url);
  //   if (urlParams.get("vuid")) {
  //     loginTrack(urlParams.get("vuid"), 0);
  //   }
  // }
  localStorage.setItem("loginUrl", "migulogin");
  window.location.href = url
}
export function getTaskIdMg( routeType ,path='/history',pId='mg-mczx') {
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  let result = getRootUrl() + path
  const url = `https://y.migu.cn/app/v5/p/ai-charging/index.html?&appId=${apps.get(pId).appId}&schannel=${apps.get(pId).schannel}&projectId=${apps.get(pId).projectId}&releaseId=${releaseId}&cburl=${encodeURIComponent(result)}#/task-id`
  if (routeType == 'replace') {
    window.location.replace(url)
  } else {
    window.location.href = url
  }
}
export function getPayUrl( routeType = 'replace' ,pId='mg-mczx') {
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  let cburl = getRootUrl() 
  cburl = cburl + `&vuid=${jsCookie.get('vuid')}&btoken=${jsCookie.get('btoken')}`
  const url = `https://y.migu.cn/app/v5/p/ai-pay/index.html?&appId=${apps.get(pId).appId}&schannel=${apps.get(pId).schannel}&projectId=${apps.get(pId).projectId}&releaseId=${releaseId}&cburl=${encodeURIComponent(cburl)}`
  if (routeType == 'replace') {
    window.location.replace(url)
  } else {
    window.location.href = url
  }
}
export function getRootUrl() {
  let str = window.location.href;
  let parts = str.split("/");
  // 截取第三个 / 前面的部分
  let result = parts.slice(0, 5).join("/");
  return result
}
export function getRandomInt(arr) {
  return Math.floor(Math.random() * arr.length);
}
export function setEvent(data,page_name='aigc_studio') {
  let localToken = JSON.parse(localStorage.getItem('tokens'))?.tokens.ticket
  const token = jsCookie.get('ticket') || localToken;
  console.log(localStorage.getItem('tokens'))
  fetch(process.env.VUE_APP_BASE_URL + '/api/dc/v1/events', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(
      {
        channel_id: 'default',
        device_id: '',
        event_time: new Date().getTime(),
        page_name,
        ...data,
  
      }
    )
  })
}
// export function loginTrack(vuid, loginResult) {
//       _amberTrack("music_aigc_login",[{
//         EK:"appId",
//         EV:apps.get("mg-mczx").appId
//       },
//       {
//         EK:"scene",
//         EV:apps.get("mg-mczx").projectId
//       },
//       {
//         EK:"vuid",
//         EV:vuid
//       },
//       {
//         EK:"channel",
//         EV:apps.get("mg-mczx").schannel
//       },   
//       {
//         EK:"triggerType",
//         EV:"2"
//       },   
//       {
//         EK:"loginResult",
//         EV:loginResult
//       }]);
// }
// export function submitCompleteTrack(vuid, taskId, templateId, templateName, videoUrl) {
//       _amberTrack("music_aigc_submit_task_directly",[{
//         EK:"appId",
//         EV:apps.get("mg-mczx").appId
//       },
//       {
//         EK:"scene",
//         EV:apps.get("mg-mczx").projectId
//       },
//       {
//         EK:"vuid",
//         EV:vuid
//       },
//       {
//         EK:"channel",
//         EV:apps.get("mg-mczx").schannel
//       },   
//       {
//         EK:"triggerType",
//         EV:"2"
//       },   
//       {
//         EK:"taskId",
//         EV:taskId
//       },   
//       {
//         EK:"templateId",
//         EV:templateId
//       },   
//       {
//         EK:"templateName",
//         EV:templateName
//       },   
//       {
//         EK:"videoUrl",
//         EV:videoUrl
//       }]);
// }
